/**
 * Global sound effects manager
 * Allows playSoundEffect to access context values without requiring hooks
 */

let soundsEnabled = true;
let soundsVolume = 0.5;

export function setSoundSettings(enabled, volume) {
  soundsEnabled = enabled;
  soundsVolume = volume;
}

export function getSoundSettings() {
  return { soundsEnabled, soundsVolume };
}
